import styles from './page.module.css'

export default function Team() {
    const ceo_profile =
    {
        first_name: "Brook",
        last_name: "Fekadu",
        role: "CEO",
        department: "Healthcare technology strategy & regional expansion",
        desc: "Founder and CEO with 18+ years leading medical equipment operations in Ethiopia and Kenya. Oversees GE Healthcare partnership and strategic growth.",
        img_url: "/images/profiles/Brook-Fekadu-CEO.webp"
    }


    const profiles = [
        {
            first_name: "Rebeka",
            last_name: "Yeshanew",
            role: "General Manager",
            department: "Operations & Institutional relationships",
            desc: "Leads Infinity's strategic operations, government relationships, and institutional procurement across Ethiopia's public and private healthcare sectors.",
            img_url: "/images/profiles/Rebeka-Yeshanew.webp"
        },
        {
            first_name: "Miheret",
            last_name: "Mulatu",
            role: "Deputy General Manager",
            department: "Kenya operations & business development",
            desc: "MBA-qualified director leading Infinity's Kenya operations, building new hospital relationships and expanding the service network across the country.",
            img_url: "/images/profiles/Mihret-Mulatu.webp"
        },
        {
            first_name: "Fesseha",
            last_name: "Mehari",
            role: "Medical Division Head",
            department: "",
            desc: "",
            img_url: "/images/profiles/Fesseha-Mehari.webp"
        },
        {
            first_name: "Mekbib",
            last_name: "Bizuneh",
            role: "IT Division Head",
            department: "",
            desc: "",
            img_url: "/images/profiles/Mekbib-Bizuneh.webp"
        },
        {
            first_name: "Birtukan",
            last_name: "Sisay",
            role: "Finance Manager",
            department: "",
            desc: "",
            img_url: "/images/profiles/Birtukan.webp"
        },
        {
            first_name: "Yordanos",
            last_name: "Kehasey",
            role: "Sales Department Manager",
            department: "",
            desc: "",
            img_url: "/images/profiles/Yordanos-Kahsay.webp"
        },
        {
            first_name: "Meron",
            last_name: "Assefa",
            role: "T.Service Department Manager",
            department: "",
            desc: "",
            img_url: "/images/profiles/Meron-Aseffa.webp"
        },
        {
            first_name: "Bethelhem",
            last_name: "Tamrat",
            role: "Marketing Manager",
            department: "",
            desc: "",
            img_url: "/images/profiles/Bethelehem-Tamrat.webp"
        },
        {
            first_name: "Samuel",
            last_name: "Semu",
            role: "Finance Operations Manager",
            department: "",
            desc: "",
            img_url: "/images/profiles/Samuel-Semu.webp"
        }
    ]
    return (
        <main>
            <section className="pageHero">
                <div className="container">
                    <span className="pageHeroLabel">Leadership</span>
                    <h1 className="pageHeroTitle">Experienced Team, Deep Expertise</h1>
                    <p className="pageHeroDesc">
                        Infinity&apos;s success is driven by healthcare professionals, biomedical engineers, technical specialists, project managers, and business leaders.
                    </p>
                </div>
            </section>

            <section className={styles.content}>
                <div className={styles.ceocard}>
                    <img className={styles.img} src={ceo_profile.img_url} />
                    <section>
                        <h1>{ceo_profile.first_name + " " + ceo_profile.last_name}</h1>
                        <p className={styles.label}>{ceo_profile.role}</p>
                        <p className={styles.desc}>{ceo_profile.desc}</p>
                    </section>
                </div>

                {
                    profiles.map((e, idx) => {
                        return <div className={styles.card} key={idx}>
                            <img className={styles.img} src={e.img_url} />
                            <section>
                                <h1>{e.first_name + " " + e.last_name}</h1>
                                <p className={styles.label}>{e.role}</p>
                                {/* <p className={styles.desc}></p> */}
                            </section>
                        </div>

                    })
                }

               



            </section>

        </main>
    )
}